<dp-loading-spinner *ngIf="isLoading" message="Submitting Request" />

<div class="container d-flex justify-content-center align-items-center py-5">
  <div class="bg-white p-4 rounded shadow">
    <h2 class="text-center text-primary mb-4">
      Create Request for {{ reportTypeName }}
    </h2>
    <form #form="ngForm" (ngSubmit)="runCaptcha(form)">
      <div>
        <div class="card mb-3">
          <div class="card-header text-bg-primary">
            Case Details
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="patientFirstName" class="form-label app-required">Patient First Name</label>
                <input id="patientFirstName"
                       type="text"
                       [(ngModel)]="lead.patientFirstName"
                       name="patientFirstName"
                       class="form-control"
                       required
                       maxlength="50"
                       #patientFirstName="ngModel" />
                <div class="text-danger"
                     *ngIf="patientFirstName.invalid && patientFirstName.errors && (patientFirstName.touched || form.submitted)">
                  <div *ngIf="patientFirstName.errors['required']">
                    The Patient First Name field is required
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="patientLastName" class="form-label app-required">Patient Last Name</label>
                <input id="patientLastName"
                       type="text"
                       [(ngModel)]="lead.patientLastName"
                       name="patientLastName"
                       class="form-control"
                       required
                       maxlength="50"
                       #patientLastName="ngModel" />
                <div class="text-danger"
                     *ngIf="patientLastName.invalid && patientLastName.errors && (patientLastName.touched || form.submitted)">
                  <div *ngIf="patientLastName.errors['required']">
                    The Patient Last Name field is required
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="state" class="form-label app-required">State Filed In</label>
                <select id="state"
                        [(ngModel)]="lead.state"
                        (ngModelChange)="onStateChange()"
                        name="state"
                        class="form-select"
                        required
                        #state="ngModel">
                  <option [ngValue]="undefined">Select State</option>
                  <option *ngFor="let state of allStates" [value]="state.code">
                    {{state.name}}
                  </option>

                </select>
                <div class="text-danger"
                     *ngIf="state.invalid && state.errors && (state.touched || form.submitted)">
                  <div *ngIf="state.errors['required']">
                    The State field is required
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3" *ngIf="lead.state === 'FL' || lead.state === 'NJ'">
                <label for="dataRequested" class="form-label app-required">Data Requested</label>
                <ng-select
                           [items]="filteredDataTypes"
                           bindLabel="name"
                           bindValue="id"
                           name="dataRequested"
                           [multiple]="true"
                           [closeOnSelect]="false"
                           [(ngModel)]="lead.requestedDataTypes">
                </ng-select>

              </div>
            </div>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-header text-bg-primary">
            Contact
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="lawyerFirstName" class="form-label app-required">Lawyer First Name</label>
                <input id="lawyerFirstName"
                       type="text"
                       [(ngModel)]="lead.lawyer!.firstName"
                       name="lawyerFirstName"
                       class="form-control"
                       required
                       maxlength="50"
                       #lawyerFirstName="ngModel" />
                <div class="text-danger"
                     *ngIf="lawyerFirstName.invalid && lawyerFirstName.errors && (lawyerFirstName.touched || form.submitted)">
                  <div *ngIf="lawyerFirstName.errors['required']">
                    The Lawyer First Name field is required
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="lawyerLastName" class="form-label app-required">Lawyer Last Name</label>
                <input id="lawyerLastName"
                       type="text"
                       [(ngModel)]="lead.lawyer!.lastName"
                       name="lawyerLastName"
                       class="form-control"
                       required
                       maxlength="50"
                       #lawyerLastName="ngModel" />
                <div class="text-danger"
                     *ngIf="lawyerLastName.invalid && lawyerLastName.errors && (lawyerLastName.touched || form.submitted)">
                  <div *ngIf="lawyerLastName.errors['required']">
                    The Lawyer last Name field is required
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="lawyerEmail" class="form-label app-required">Lawyer Email</label>
                <input id="lawyerEmail"
                       type="email"
                       [(ngModel)]="lead.lawyer!.email"
                       name="lawyerEmail"
                       class="form-control"
                       required
                       maxlength="100"
                       #lawyerEmail="ngModel" />
                <div class="text-danger"
                     *ngIf="lawyerEmail.invalid && lawyerEmail.errors && (lawyerEmail.touched || form.submitted)">
                  <div *ngIf="lawyerEmail.errors['required']">
                    The Lawyer Email field is required
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="lawyerPhone" class="form-label app-required">Lawyer Phone Number</label>
                <input id="lawyerPhone"
                       type="tel"
                       [(ngModel)]="lead.lawyer!.phone"
                       name="lawyerPhone"
                       class="form-control"
                       maxlength="25"
                       required
                       #lawyerPhone="ngModel" />
                <div class="text-danger"
                     *ngIf="lawyerPhone.invalid && lawyerPhone.errors && (lawyerPhone.touched || form.submitted)">
                  <div *ngIf="lawyerPhone.errors['required']">
                    The Lawyer Phone field is required
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="lawFirmName" class="form-label app-required">Law Firm Name</label>
                <input id="lawFirmName"
                       type="text"
                       [(ngModel)]="lead.lawyer!.lawFirm!.name"
                       name="lawFirmName"
                       class="form-control"
                       required
                       maxlength="100"
                       #lawFirmName="ngModel" />
                <div class="text-danger"
                     *ngIf="lawFirmName.invalid && lawFirmName.errors && (lawFirmName.touched || form.submitted)">
                  <div *ngIf="lawFirmName.errors['required']">
                    The Law Firm Name field is required
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <re-captcha
                  #captchaRef="reCaptcha"
                  [siteKey]="siteKey"
                  size="invisible"
                  (resolved)="onCaptchaResolved($event)">
      </re-captcha>

      <div *ngIf="validationErrors.length > 0" class="text-danger">
        <ul>
          <li *ngFor="let error of validationErrors">
            {{error}}
          </li>
        </ul>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <a routerLink="/" class="btn btn-secondary me-3 w-100">Cancel</a>
        <button type="submit" class="btn btn-primary w-100">Save</button>
      </div>
    </form>
  </div>
</div>